<template>
  <div>
    <Create v-if="showCreateBtn" :createDialog="createDialog" @close="close" @created="created">
    </Create>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ title }}</h1>
        </v-toolbar-title>
        <v-btn
          color="teal"
          dark="dark"
          small="small"
          absolute="absolute"
          bottom="bottom"
          right="right"
          fab="fab"
          v-if="showCreateBtn"
          @click="add"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 sm4="sm4">
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            clearable="clearable"
            single-line="single-line"
            hide-details="hide-details"
          >
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="ticket"
        :search="search"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.id, search)" @click="props.expanded = !props.expanded">
              {{ props.item.id }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
            </td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.title, search)" @click="props.expanded = !props.expanded">
              {{ props.item.title }}
            </td>
            <td
              class="text-xs-left" v-html="$options.filters.highlight(props.item.assignedToUser.fullName, search)"
              v-if="props.item.assignedToUser &amp;&amp; props.item.assignedToUser.fullName"
              @click="props.expanded = !props.expanded"
            >
              {{ props.item.assignedToUser.fullName }}
            </td>
            <td class="text-xs-left" v-else @click="props.expanded = !props.expanded">
              n/a
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ $moment(props.item.dueDate).format("MM/DD h:m a") }}
            </td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.statusDetail.selector, search)" @click="props.expanded = !props.expanded">
              {{ props.item.statusDetail.selector }}
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card>
            <v-card-text>
              <v-card class="elevation-15" dark color="#1B1B1D">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-layout column>
                        <v-flex>
                          <h3 class="font-weight-bold mb-3" style="color: #21C593;">Ticket</h3>
                          <div class="font-weight-bold">{{ $t("labels.title") }}</div>
                          <div>{{ props.item.title }}</div>
                          <div class="mt-1 font-weight-bold">{{ $t("labels.description") }}</div>
                          <div class="">{{ props.item.description }}</div>
                          <div class="mt-1 font-weight-bold" v-if="props.item.solution">
                            {{ $t("labels.solution") }}
                          </div>
                          <div class="">{{ props.item.solution }}</div>
                        </v-flex>
                        <v-flex class="mt-3" v-if="props.item.softwareID === 54">
                          <h3 class="font-weight-bold mb-3" style="color: #21C593;">2.0 Software</h3>
                          <div class="font-weight-bold">Dropbox check</div>
                          <div v-if="!props.item.dropbox"><v-icon small color="red" >close</v-icon></div>
                          <div v-else><v-icon color="green" >mdi-check</v-icon></div>
                          <div class="mt-1 font-weight-bold">{{ $t("labels.version") }}</div>
                          <div v-if="props.item.version">{{ props.item.version }}</div>
                          <div v-else >N/A</div>
                          <div class="mt-1 font-weight-bold" v-if="props.item.solution">
                            {{ $t("labels.solution") }}
                          </div>
                          <div class="">{{ props.item.solution }}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <h3 class="font-weight-bold mb-3" style="color: #21C593;">Contact</h3>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.name") }}</div>
                      <div class="">{{ props.item.name }}</div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.phoneNumber") }}</div>
                      <div>{{ props.item.phoneNumber }}</div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.emailAddress") }}</div>
                      <div>{{ props.item.email }}</div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.status") }}</div>
                      <div>{{ props.item.statusDetail.selector }}</div>
                    </v-flex>

                    <v-layout row wrap>
                      <v-btn color="info" @click="gotoPage(props.item)">Go to page</v-btn>
                      <v-btn color="info" flat="flat" @click="gotoPageNewTab(props.item)">
                        <v-icon left="left">open_in_new </v-icon>Open in new tab</v-btn
                      >
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ticketService from "../service.js";
const Create = () => import("./Create");

import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    title: {
      type: String,
      default: "Tickets"
    },
    ticket: {
      type: Array,
      default: []
    },
    showCreateBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      createDialog: false,
      expand: false,
      headers: [
        {
          text: this.$t("labels.ticketNumber"),
          value: "id",
          sortable: true,
          width: "5%"
        },
        {
          text: this.$t("labels.createdAt"),
          value: "createdAt",
          sortable: true,
          width: "15%"
        },
        {
          text: this.$t("labels.title"),
          value: "title",
          sortable: true
        },
        {
          text: this.$t("labels.assignedTo"),
          value: "assignedToUser.fullName",
          sortable: true
        },
        {
          text: this.$t("labels.dueDate"),
          value: "dueDate",
          sortable: true
        },
        {
          text: this.$t("labels.status"),
          value: "statusDetail.selector",
          sortable: true
        }
      ],
      search: '',
      loading: true,
      pagination: {
        rowsPerPage: 10,

        sortBy: "id",
        descending: true
      }
    };
  },
  components: {
    Create
  },
  methods: {
    close() {
      this.createDialog = false;
    },
    created() {
      this.$emit("created");
      this.close();
    },
    gotoPage(data) {
      this.$router.push({ path: `/tickets/profile/${data.id}` });
    },
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({
        path: `/tickets/profile/${data.id}`
      });
      window.open(routeData.href, "_blank");
    },
    add() {
      this.createDialog = true;
    }
  }
};
</script>

<style scoped></style>
